import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "ll-custom-flag-select"
};
import { storeToRefs } from 'pinia';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
export default {
  __name: 'LlCustomFlagSelect',
  props: {
    modelValue: {
      type: [Object, String, null],
      default: null
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: 'pr-2 py-1'
    },
    componentClass: {
      type: String,
      default: 'at-choose-client remove-outline'
    },
    placeholder: {
      type: String,
      default: 'Select Custom Flag'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      default: 'custom-flag-filter'
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      customFlagLabel
    } = storeToRefs(useCompanyStore());
    const props = __props;
    const emit = __emit;

    // Custom flag options from constants
    const customFlagOptions = [{
      label: 'Include',
      id: 'any'
    }, {
      label: 'Exclude',
      id: 'false'
    }, {
      label: 'Only',
      id: 'true'
    }];
    const handleChange = value => {
      emit('update:modelValue', value);
      emit('change', value);
    };
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.hideLabel ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass(["text-sm", __props.labelClass])
      }, _toDisplayString(__props.label || _unref(customFlagLabel) || 'Custom Flag'), 3)) : _createCommentVNode("", true), _createVNode(_component_v_autocomplete, {
        "model-value": __props.modelValue,
        items: customFlagOptions,
        density: "compact",
        "item-title": "label",
        "item-value": "id",
        "return-object": __props.returnObject,
        variant: "outlined",
        "hide-details": __props.hideDetails,
        class: _normalizeClass(__props.componentClass),
        placeholder: __props.placeholder,
        clearable: __props.clearable,
        disabled: __props.disabled,
        searchable: __props.searchable,
        "data-cy": __props.dataCy,
        "onUpdate:modelValue": handleChange
      }, null, 8, ["model-value", "return-object", "hide-details", "class", "placeholder", "clearable", "disabled", "searchable", "data-cy"])]);
    };
  }
};